module.exports = __webpack_public_path__ + "static/img/9710.7412d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BToB/9710.png
// module id = 367C
// module chunks = 1